<template>
  <section class="content">
    <div class="box box-solid">
      <div class="box-body">
        <div style="display: inline-flex;flex-wrap: wrap;width: 100%;">
          <DatePicker v-model="salesFrom" :last="salesTo"/>
          <h4 style="margin:5px 10px;">~</h4>
          <DatePicker v-model="salesTo" :first="salesFrom" style="margin-right:10px"/>
          <button type="button" class="btn btn-default" style="margin-right:10px" @click="onPrvMonth">전월</button>
          <button type="button" class="btn btn-default" style="margin-right:10px" @click="onNowMonth">당월</button>
          <button type="button" class="btn btn-default" @click="refreshPage">검색</button>
        </div>
      </div>
    </div>
    <div class="box box-solid">
      <div class="box-body">
        <line-chart :legend="false" :data="chatdata" />
      </div>
    </div>
    <div class="row" style="margin:0px;margin-bottom:20px">
      <button type="button" class="btn btn-default pull-right" @click="downExcel" :disabled="buttonDissabled">
        <i class="fa fa-download"></i>Excel
      </button>
    </div>
    <div class="box box-solid">
      <div class="box-body table-responsive p-0">
        <table class="table table-hover text-nowrap">
          <thead>
            <tr>
              <th>날짜</th>
              <th>거래금액</th>
              <th>목표금액</th>
              <th>달성율</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>합계</td>
              <td>{{totalamount.salesAmount | numFormat}}</td>
              <td>{{totalamount.targetAmount | numFormat}}</td>
              <td>{{percent(totalamount.salesAmount, totalamount.targetAmount)}}</td>
            </tr>
            <tr v-for="(data, idx) in content" :key="idx">
              <td>{{viewDate(data.salesDate)}}</td>
              <td>{{data.salesAmount | numFormat}}</td>
              <td>{{data.targetAmount | numFormat}}</td>
              <td>{{percent(data.salesAmount, data.targetAmount)}}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </section>
</template>

<script>
import { rescode, menuval } from "../../../lib/consts";
import routepath from "../../../lib/routes";
import { reqPost } from "../../../lib/request";
import { orderapi } from "../../../lib/api";
import { DateFormat, getPercent } from "../../../lib/utility";
import DatePicker from "../../../components/DatePicker";
import moment from 'moment';
import XLSX from "xlsx";
export default {
  components: {
    DatePicker,
  },
  created() {
    this.$store.dispatch('doSetPath', {path1:menuval.LV1_STAT, path2:menuval.LV2_STT_DPL, title:"거래현황 목표대비"});
  },
  data() {
    return {
      chatdata:[
        {data: {'1': 3, '2': 4}},
        {data: {'1': 5, '2': 3}}
      ],
      salesFrom:moment().format("YYYY-MM-01"),
      salesTo:moment().format("YYYY-MM-DD"),
      content:[],
      /**
       * salesDate                String    yyyy-MM-dd  날짜
       * grossSalesAmount             String    목표 금액
       * salesAmount              String    매출액 (구매금액)
       * cancelledAmount          String    취소금액
       * netSalesAmount           String    순매출액
       */
      totalamount:{
        grossSalesAmount:0,//목표 금액
        salesAmount:0,//매출액 (구매금액)
        cancelledAmount:0,//취소금액
      },
      currencyCode:"KRW",
      buttonDissabled : false,
    };
  },
  computed: {
    routes() {
      return routepath;
    },
    authToken() {
      return this.$store.getters.authToken;
    },
  },
  mounted() {
    this.refreshPage();
  },
  methods: {
    viewDate(val) {
      return DateFormat(val, "YYYY-MM-DD", true);
    },
    refreshPage() {
      reqPost(
        orderapi.base,
        orderapi.totalizePurchasedSales,
        this.authToken,
        {
          salesFrom:this.salesFrom,
          salesTo:this.salesTo
        },
        (result) => {
          if (result != null) {
            if (result.code == rescode.REQ_SUCCESS) {
              this.doCalcuTotal(result.data.sales);
              this.currencyCode = result.data.currencyCode;
            } else {
              this.content = [];
              alert(result.message);
            }
          }
        }
      );
    },
    percent(sales, target){
      return getPercent(sales, target);
    },
    onNowMonth()
    {
      this.salesFrom = moment().format("YYYY-MM-01");
      this.salesTo = moment().format("YYYY-MM-DD");
    },
    onPrvMonth()
    {
      this.salesFrom = moment().subtract(1,'months').format('YYYY-MM-01');
      this.salesTo = moment().subtract(1,'months').endOf('month').format('YYYY-MM-DD');
    },
    doCalcuTotal(sales)
    {
      this.totalamount = {
        grossSalesAmount:0,//목표 금액
        salesAmount:0,//매출액 (구매금액)
        cancelledAmount:0,//취소금액
        targetAmount: 0
      };
      this.chatdata = [];
      var chatdata1 = {};
      var chatdata2 = {};

      for(var idx=0;idx<sales.length; idx++)
      {

        if(sales[idx].grossSalesAmount != null)
        {
          this.totalamount.grossSalesAmount = this.totalamount.grossSalesAmount + parseInt(sales[idx].grossSalesAmount);
        }
        if(sales[idx].salesAmount != null)
        {
          this.totalamount.salesAmount = this.totalamount.salesAmount + parseInt(sales[idx].salesAmount);
        }
        if(!isNaN(parseInt(sales[idx].targetAmount)))
        {
          this.totalamount.targetAmount = this.totalamount.targetAmount + parseInt(sales[idx].targetAmount);
        }
        if(sales[idx].cancelledAmount != null)
        {
          this.totalamount.cancelledAmount = this.totalamount.cancelledAmount + parseInt(sales[idx].cancelledAmount);
        }
        chatdata1[sales[idx].salesDate] = parseInt(sales[idx].salesAmount);
        chatdata2[sales[idx].salesDate] = !isNaN(parseInt(sales[idx].targetAmount)) ? parseInt(sales[idx].targetAmount) : 0;
      }
      this.content = sales;
      this.chatdata.push({data:chatdata1, color:'#5B9BD5'});
      this.chatdata.push({data:chatdata2, color:'#A5A5A5'});
    },
    dataconvert(tdata) {
      return {
        A: this.viewDate(tdata.salesDate),
        B: tdata.salesAmount,
        C: tdata.targetAmount,
        D: this.percent(tdata.salesAmount, tdata.targetAmount),
      };
    },
    downExcel() {
      this.buttonDissabled = true;
      var excelheader = XLSX.utils.json_to_sheet(
        [
          {
            A: "날짜",
            B: "거래금액",
            C: "목표금액",
            D: "달성율",
          },
          {
            A: "합계",
            B: this.totalamount.salesAmount,
            C: this.totalamount.targetAmount,
            D: this.percent(this.totalamount.salesAmount, this.totalamount.targetAmount),
          },
        ],
        { skipHeader: true }
      );

      XLSX.utils.sheet_add_json(excelheader, this.content.map(this.dataconvert), {
        skipHeader: true,
        origin: "A3",
      });
      var wb = XLSX.utils.book_new(); // make Workbook of Excel

      XLSX.utils.book_append_sheet(wb, excelheader, "목표대비");
      // export Excel file
      XLSX.writeFile(wb, "거래현황조회-목표대비.xlsx");
      this.buttonDissabled = false;
    },
  },
};
</script>

<style scoped>
.checkbox > label {
  margin-right: 10px;
}

.radio > label {
  margin-right: 10px;
}

.form-horizontal .form-group{
  margin-left: 0px;
  margin-right: 0px;
}
th {
  text-align: center;
}
td {
  text-align: center;
}
</style>
